/* Longsands Repel Bundle Builder. Product data is fetched from Shopify storefront JSON. */
(() => {
  const HOODIES = ['longsands-repeltech-hoodies', 'longsands-repeltech-hoodie-black'];
  const BEANIES = ['old-rose','loganberry','lavender-frost','north-sea','retro','winter-moss','spiced-plum','icecream-milkshake'].map(s => 'adults-wooler-beanie-' + s);
  const root = document.getElementById('repel-bundle-builder');
  if (!root) return;
  const $ = s => root.querySelector(s);
  const state = {hoodies: [], beanies: [], hoodie: null, beanie: null, variant: null, step: 0, busy: false};
  const routes = window.Shopify?.routes?.root || '/';
  const imageUrl = p => (p.image?.src || p.featured_image || p.images?.[0]?.src || p.images?.[0] || '').replace(/^\/\//,'https://');
  const label = p => p.handle.replace(/^longsands-repeltech-hoodie(s)?-?|^adults-wooler-beanie-/, '').replace(/-/g, ' ').replace(/\b\w/g, m=>m.toUpperCase()) || p.title;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  async function fetchProduct(handle) {
    const res = await fetch(routes + 'products/' + encodeURIComponent(handle) + '.js', {credentials:'same-origin'});
    if (!res.ok) throw new Error('Product unavailable: ' + handle);
    return res.json();
  }
  let loadPromise;
  function load() {
    if (!loadPromise) loadPromise = Promise.all([Promise.all(HOODIES.map(fetchProduct)),Promise.all(BEANIES.map(fetchProduct))]).then(([h,b])=>{state.hoodies=h;state.beanies=b;});
    return loadPromise;
  }
  function showError(msg, general=false) {const el = $(general?'[data-rb-general-error]':'[data-rb-error]'); el.textContent=msg;el.hidden=!msg;}
  function available(p) {return p.variants.some(v=>v.available);}
  function choiceHTML(p,selected) {return `<button type="button" class="rb-choice" data-rb-choice="${esc(p.handle)}" aria-pressed="${p.handle===selected}" ${available(p)?'':'disabled'}><img src="${esc(imageUrl(p))}" alt="${esc(p.title)}" loading="lazy"><strong>${esc(label(p))}</strong>${available(p)?'':'<small>Sold out</small>'}</button>`;}
  function chooseDefaults(handle) {
    state.hoodie=state.hoodies.find(p=>p.handle===handle) || state.hoodies.find(available) || null;
    state.beanie=state.beanies.find(p=>p.handle===handle) || state.beanies.find(available) || null;
    state.variant=null;
    if (state.hoodie) {
      const selectedId = new URLSearchParams(location.search).get('variant');
      state.variant = BEANIES.includes(handle) ? null : (state.hoodie.variants.find(v=>String(v.id)===selectedId && v.available) || state.hoodie.variants.find(v=>v.available) || null);
    }
  }
  const formatPrice = cents => new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format((Number(cents)||0)/100);
  function render() {
    $('[data-rb-hoodies]').innerHTML=state.hoodies.map(p=>choiceHTML(p,state.hoodie?.handle)).join('');
    $('[data-rb-beanies]').innerHTML=state.beanies.map(p=>choiceHTML(p,state.beanie?.handle)).join('');
    const select=$('[data-rb-size]');
    select.innerHTML='<option value="">Choose a size</option>'+(state.hoodie?.variants || []).map(v=>`<option value="${v.id}" ${v.available?'':'disabled'} ${v.id===state.variant?.id?'selected':''}>${esc(v.title)}${v.available?'':' — Sold out'}</option>`).join('');
    $('[data-rb-review]').innerHTML=`<div class="rb-review-line"><span>Repel Hoody — ${esc(label(state.hoodie || {handle:''}))} / ${esc(state.variant?.title)}</span><strong>${formatPrice(state.variant?.price)}</strong></div><div class="rb-review-line"><span>Wooler Beanie — ${esc(label(state.beanie || {handle:''}))}</span><strong>FREE</strong></div>`;
    $('[data-rb-total-price]').textContent=formatPrice(state.variant?.price);
    root.querySelectorAll('[data-rb-step]').forEach(el=>el.hidden=Number(el.dataset.rbStep)!==state.step);
    root.querySelectorAll('.rb-steps span').forEach((el,i)=>el.classList.toggle('is-active',i===state.step));
  }
  function setStep(n) {state.step=n;render();$('.rb-dialog').scrollTop=0;}
  let priorFocus=null;
  async function open(handle) {
    priorFocus=document.activeElement;
    root.hidden=false;document.body.classList.add('rb-lock');
    showError('',true);$('[data-rb-hoodies]').textContent='Loading available hoodies…';
    $('[data-rb-beanies]').textContent='Loading beanies…';
    root.querySelectorAll('[data-rb-step]').forEach(el=>el.hidden=true);
    $('.rb-dialog').focus();
    try {await load();chooseDefaults(handle);setStep(0);}
    catch(e) {showError('We could not load the bundle options. Please refresh and try again.',true);}
  }
  function close(){root.hidden=true;document.body.classList.remove('rb-lock');priorFocus?.focus?.();}
  document.addEventListener('click',e=>{
    const trigger=e.target.closest('[data-rb-open]');
    if (!trigger) return;
    e.preventDefault();
    const handle=trigger.dataset.rbHandle || trigger.closest('[data-rb-product-promo]')?.dataset.handle || (document.body.dataset.productHandle || '');
    open(handle);
  });
  root.addEventListener('click',e=>{
    if(e.target.closest('[data-rb-close]')){close();return;}
    const choice=e.target.closest('[data-rb-choice]');
    if(choice){const h=choice.dataset.rbChoice;if(HOODIES.includes(h)){state.hoodie=state.hoodies.find(p=>p.handle===h);state.variant=state.hoodie.variants.find(v=>v.available)||null;}else{state.beanie=state.beanies.find(p=>p.handle===h);}render();return;}
    if(e.target.closest('[data-rb-back]'))setStep(Math.max(0,state.step-1));
    if(e.target.closest('[data-rb-next]')){
      if(state.step===0&&!state.variant){showError('Please choose an available hoody size.',true);return;}
      if(state.step===1&&!state.beanie){showError('Please choose an available beanie.',true);return;}
      showError('',true);setStep(Math.min(2,state.step+1));
    }
  });
  $('[data-rb-size]').addEventListener('change',e=>{state.variant=state.hoodie?.variants.find(v=>String(v.id)===e.target.value&&v.available)||null;});
  $('[data-rb-add]').addEventListener('click',async()=>{
    if(state.busy)return;
    if(!state.variant?.available||!state.beanie){showError('Choose available products first.');return;}
    const bv=state.beanie.variants.find(v=>v.available);
    if(!bv){showError('Sorry, that beanie is sold out. Please choose another.');return;}
    state.busy=true;const button=$('[data-rb-add]');button.disabled=true;button.textContent='ADDING TO BAG…';showError('');
    try {
      const properties={'_Repel bundle':'Yes'};
      if($('[data-rb-gift]').checked)properties['Gift packaging']='Yes — complimentary Longsands gift box';
      else properties['Gift packaging']='No';
      const response=await fetch(routes+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:state.variant.id,quantity:1,properties},{id:bv.id,quantity:1,properties:{'_Repel bundle':'Yes'}}]})});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description||result.message||'Unable to add the bundle.');
      // Full cart navigation ensures this theme recalculates the existing automatic discount and renders both lines reliably.
      window.location.assign(routes+'cart');
    }catch(e){showError(e.message||'Could not add bundle. Please try again.');state.busy=false;button.disabled=false;button.textContent='ADD BUNDLE TO BAG';}
  });
  document.addEventListener('keydown',e=>{
    if(root.hidden)return;
    if(e.key==='Escape')close();
    if(e.key==='Tab'){
      const focusable=[...root.querySelectorAll('button:not([disabled]),select:not([disabled]),input:not([disabled])')].filter(el=>el.getClientRects().length);
      if(!focusable.length)return;
      const first=focusable[0],last=focusable[focusable.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    }
  });
  const promo=document.querySelector('[data-rb-product-promo]');
  if(promo){
    const placePromo=()=>{
      const buyBlock=document.querySelector('.product-information .buy-buttons-block, .product-information__details .buy-buttons-block, .buy-buttons-block');
      if(buyBlock){buyBlock.insertAdjacentElement('afterend',promo);return true;}
      return false;
    };
    if(!placePromo()){
      // Do not leave the promo as a large grid child if the product form is still loading.
      promo.hidden=true;
      const observer=new MutationObserver(()=>{if(placePromo()){promo.hidden=false;observer.disconnect();}});
      observer.observe(document.body,{childList:true,subtree:true});
      setTimeout(()=>observer.disconnect(),10000);
    }
  }
  if(new URLSearchParams(location.search).get('bundle')==='1')open(new URLSearchParams(location.search).get('bundle_product')||'');
})();
